import * as React from 'react';
import { Form } from './Form';

export interface SaveableState {
    saved: boolean;
}

export class Saveable<P, S extends SaveableState> extends Form<P, S> {
    markSaved(saved: boolean, state?: S) {
        state = state || this.state;
        this.setState({...state as object, saved});
    }
    renderSave() {
        return this.state.saved ? (
            <div>
                <span className="badge badge-success p-2">Saved</span>
            </div>
        ) : null;
    }
    saved() {
        return this.state.saved;
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Saveable.tsx